module.exports = __webpack_public_path__ + "img/inbox-unarchive-fill.6cae2850.svg";